var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.26 11.58L13.07 7.43005L5.86996 3.28005C5.61996 3.14005 5.33996 3.14005 5.09996 3.28005C4.84996 3.42005 4.70996 3.66005 4.70996 3.95005V20.56C4.70996 20.84 4.84996 21.09 5.09996 21.23C5.34996 21.37 5.62996 21.37 5.86996 21.23L13.06 17.08L20.25 12.93C20.5 12.79 20.64 12.55 20.64 12.26C20.64 11.97 20.5 11.73 20.25 11.59L20.26 11.58Z",
    fill: "#E4EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4834 3.92603L5.50391 3.93481L12.6953 8.07935L19.0371 11.7405L19.0186 11.76L19.8838 12.2444C19.8857 12.2455 19.8873 12.2464 19.8887 12.2473C19.889 12.2503 19.8896 12.2545 19.8896 12.26C19.8896 12.265 19.889 12.2688 19.8887 12.2717L19.8838 12.2756L19.875 12.2805L12.6846 16.4309L5.49512 20.5803L5.49219 20.5823C5.48967 20.5837 5.48742 20.5838 5.48633 20.5842C5.48321 20.5834 5.47671 20.581 5.4668 20.5754C5.4642 20.574 5.46195 20.5733 5.46094 20.5725L5.45996 20.5715V3.95044C5.45996 3.94514 5.46061 3.94072 5.46094 3.93774C5.46243 3.93678 5.46462 3.93603 5.4668 3.93481L5.47754 3.92798C5.47958 3.92679 5.48132 3.92554 5.48242 3.92505L5.4834 3.92603Z",
    fill: "#E4EDFF",
    stroke: "#052A75",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.2b31b4ead1aa4fffbeeeea424a21b3ff.svg";
export { ForwardRef as ReactComponent };